export class ModalityDTO {
	constructor(
		public id: number = null,
		public value?: string,
		public description?: string,
		public defaultAETitle?: string,
		public color: string = '#e2e2e2'
	) {}
}
